/**
 * Nhãn từng mã cờ — mỗi lý do một chip riêng (BR-210), không gộp thành "đáng ngờ".
 *
 * `BILL_TIME_UNKNOWN` và `MEMBER_SELF_SCAN` gần như mọi lần quét tương ứng; hiện chúng
 * sẽ làm cột lý do mất chỗ cho cờ thật sự cần đọc.
 */
export const FLAG_LABELS: Record<string, { label: string; tone: 'danger' | 'warn' | 'info' }> = {
  MEMBER_VELOCITY: { label: 'Khách vượt số hóa đơn trong ngày', tone: 'danger' },
  STAFF_VELOCITY: { label: 'Nhân viên quét nhiều hóa đơn trong 1 giờ', tone: 'danger' },
  HIGH_VALUE: { label: 'Số tiền lớn', tone: 'danger' },
  MANUAL_ENTRY: { label: 'Nhập tay, có ảnh hóa đơn', tone: 'warn' },
  NO_VISIT_CONTEXT: { label: 'Không có dấu vết đã tới chi nhánh', tone: 'danger' },
  REPEAT_SAME_BRANCH_TODAY: { label: 'Hóa đơn thứ hai trở đi tại cùng chi nhánh hôm nay', tone: 'warn' },
  SHARED_DEVICE: { label: 'Cùng thiết bị, tài khoản khác', tone: 'warn' },
  NEW_MEMBER: { label: 'Tài khoản mới', tone: 'warn' },
  OUTSIDE_OPENING_HOURS: { label: 'Ngoài giờ mở cửa', tone: 'warn' },
  BILL_TIME_UNKNOWN: { label: 'Không biết giờ in hóa đơn', tone: 'info' },
  MEMBER_SELF_SCAN: { label: 'Khách tự quét', tone: 'info' },

  // Bốn lớp BR-215 + trần voucher — thiếu nhãn tới 2026-09-08, nên màn đối soát hiện thẳng mã
  // thô (`VAT_MISMATCH`) cạnh những chip đã có tiếng Việt. Người soát không đọc được mã thô sẽ
  // bỏ qua đúng cái cờ cần đọc.
  VAT_MISMATCH: { label: 'Số thuế trên hóa đơn không khớp thuế suất đã khai', tone: 'danger' },
  TIME_INCONSISTENT: { label: 'Giờ vào / giờ ra / giờ in không hợp lý', tone: 'danger' },
  CASHIER_UNKNOWN: { label: 'Tên thu ngân không thuộc chi nhánh', tone: 'danger' },
  VOUCHER_CAP_EXCEEDED: { label: 'Gắn nhiều voucher hơn trần cho phép', tone: 'danger' },

  // Không còn sinh ra từ 2026-09-08 — mã POS không chữ ký nay bị TỪ CHỐI (BR-217). Giữ nhãn để
  // hàng cũ đọc được, và nói rõ trong nhãn rằng đó là dữ liệu trước khi bắt buộc chữ ký.
  QR_UNSIGNED: { label: 'Mã QR không có chữ ký (hóa đơn trước 08/09/2026)', tone: 'info' },
};

/** Nhãn + màu Tag cho trạng thái hóa đơn quét (dùng chung ở danh sách và modal chi tiết). */
export const BILL_STATUS: Record<string, { label: string; color: string }> = {
  Accepted: { label: 'Đã cộng điểm', color: 'success' },
  PendingConfirmation: { label: 'Chờ xác nhận', color: 'warning' },
  Manual: { label: 'Nhập tay', color: 'blue' },
  Rejected: { label: 'Từ chối', color: 'error' },
  ReversalPending: { label: 'Chờ đảo điểm', color: 'orange' },
  Reversed: { label: 'Đã đảo', color: 'default' },
};

export function billStatusMeta(status: string): { label: string; color: string } {
  return BILL_STATUS[status] ?? { label: status, color: 'default' };
}

const NOISE = new Set(['BILL_TIME_UNKNOWN', 'MEMBER_SELF_SCAN']);

export function visibleFlags(flags: string[]): string[] {
  const actionable = flags.filter((code) => !NOISE.has(code));
  return actionable.length > 0 ? actionable : flags.filter((code) => FLAG_LABELS[code]);
}

export function flagMeta(code: string): { label: string; tone: 'danger' | 'warn' | 'info' } {
  return FLAG_LABELS[code] ?? { label: code, tone: 'warn' };
}
